import Vue from 'vue'
import Vuetify from 'vuetify/lib'
import VBtnGroup from './BtnGroup.vue'
import '@mdi/font/css/materialdesignicons.css'

Vue.use(Vuetify)

export default new Vuetify({
  icons: {
    iconfont: 'mdi'
  }
})

Vue.component('v-btn-group', VBtnGroup)
